import React, {forwardRef, useEffect} from 'react';

import {ButtonBase, Slide, Stack} from '@mui/material';

import {Dialog, SaveButton, Text} from 'components';
import {useLayoutStore, useSnackbarStore} from 'store';

import {useApiAdd} from './useClientApi';

import {Form, FormField, useForm} from 'form';

const styles = {
    button: {
        color: 'white.main',
        marginLeft: 4,
        fontSize: '16px'
    },
    /* switchContainer: {
        marginTop: 2,
        marginBottom: 2,
    },
    switchLabel: {
        fontSize: '14px',
        fontWeight: '500',
    } */
};

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const CreateDialog = ({onClose, onSave, open}) => {
    // const [teamType, setTeamType] = useState('home');
    
    const setShowLoading = useLayoutStore((state) => state.setShowLoading);
    const showInfo = useSnackbarStore((state) => state.show);

    const {add, loading, data, errors} = useApiAdd();

    const doCancel = () => {
        onClose && onClose();
    };

    const doSave = async (formData) => {
        try {
            const clientData = {
                ...formData,
                // type: teamType
            };
            const res = await add(clientData);
            onSave && onSave(res);
        } catch (e) {
            showInfo(e.message, {severity: 'warning'});
        }
    };

    /* const handleTypeChange = (event) => {
        setTeamType(event.target.checked ? 'guest' : 'home');
    }; */

    useEffect(() => {
        setShowLoading(loading);
        return () => {
            setShowLoading(false);
        };
    }, [loading, setShowLoading]);

    const rhf = useForm(data, errors);

    return <Dialog
        maxWidth={false}
        pt={0}
        open={open}
        TransitionComponent={Transition}
        handleClose={onClose}
        title="client.action.create2"
    >
        <Form methods={rhf.methods} onSubmit={doSave}>
            <Stack direction="column" p={2}>
                <FormField name="name" label="client.name" autoFocus/>

                {/* <Stack sx={styles.switchContainer} direction="row" alignItems="center" justifyContent="space-between">
                    <Typography sx={styles.switchLabel}>
                        <Text>client.home_or_guest</Text>
                    </Typography>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={teamType === 'guest'}
                                onChange={handleTypeChange}
                                color="primary"
                            />
                        }
                        label={teamType === 'home' ? 'Heim' : 'Gast'}
                        labelPlacement="start"
                    />
                </Stack> */}
                
                <Stack direction="row" justifyContent="flex-end" pb={1} pt={2}>
                    <ButtonBase disableRipple sx={styles.button} onClick={doCancel}>
                        <Text>ui.actions.cancel</Text>
                    </ButtonBase>
                    <SaveButton type="submit" ml={3} mt={0} mb={0} />
                </Stack>
            </Stack>
        </Form>
    </Dialog>;
};

export default CreateDialog;